module.exports = __webpack_public_path__ + "static/media/connection.0c7ab622.svg";